import React from "react";
import { useRecoilValue } from "recoil";
import { Icon } from "semantic-ui-react";

import { currentPlaylist, playlistFilter } from "./atoms";
import { applyFilter } from "./filter";

import { formatTime } from "./utils";

function Info() {
  const playlist = useRecoilValue(currentPlaylist);
  const filter = useRecoilValue(playlistFilter);

  const totalDuration = () => {
    const duration = applyFilter(playlist, filter)
      .filter((track) => track.duration && track.enabled)
      .reduce((totalTime, track) => totalTime + Math.round(track.duration), 0);

    const totalTime = Math.round(duration);

    return formatTime(totalTime);
  };

  const ready = () => {
    const list = applyFilter(playlist, filter).filter((track) => track.enabled);

    return list.every((track) => track.duration);
  };

  return (
    <div id="total-duration">
      {totalDuration()}
      {!ready() && (
        <Icon
          loading
          size="small"
          name="spinner"
          color="purple"
          style={{
            position: "absolute",
            right: 5,
            top: 8,
          }}
        />
      )}
    </div>
  );
}

export { Info };
